import React, { useState, useEffect } from "react";
// import { handleGetRequest } from "../../../services/GetTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useHistory } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { Toolbar } from "primereact/toolbar";

function ProvinceManagement() {
    const [group, setGroup] = useState([]);
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [selectedCustomers, setSelectedCustomers] = useState(null);
    const [displaySubDetailsModal, setDisplaySubDetailsModal] = useState(false);
    const [status, setstatus] = useState(false);
    const [authDetailId, setAuthDetailId] = useState([]);
    const [transHeadId, setTransHeadId] = useState([]);
    const [checked2, setChecked2] = useState(true);
    const [editable, setEditable] = useState(false);

    // useEffect(() => {
    //     const getGroup = async () => {
    //         setloading(true);
    //         // const response = await handleGetRequest("zbiz/fin/branchAuth/fetchAllPendingAuthTransactions");
    //         setGroup(response?.data);
    //         setloading(false);
    //     };
    //     getGroup();
    // }, []);

    let history = useHistory();

    const myData = [
        {
            provinceId: 176,
            provinceName: "pakistan",
            provinceCode: 196,
        },
        {
            provinceId: 256,
            provinceName: "saudi arabia",
            provinceCode: 186,
        },
    ];

    const handleAddNewSubDetails = (e, btnStatus) => {
        e.preventDefault();
        setstatus(btnStatus);
        setDisplaySubDetailsModal(true);
    };

    const onRowSelect = (event) => {
        setAuthDetailId(event.data.authDetailId);
        setTransHeadId(event.data.transHeadId);
    };

    const onHide = (name) => {
        setDisplaySubDetailsModal(false);
    };

    const switchTemplate = () => {
        return <InputSwitch checked={checked2} onChange={(e) => setChecked2(e.value)} />;
    };
    const updateClicked = (e) => {
        setEditable(true);
        history.push(`/addprovincemanagement?editable=true`);
    };
    const actionTemplate = () => {
        return (
            <div>
                <i className="pi pi-tag" onClick={updateClicked}></i>
                <i className="pi pi-trash"></i>
            </div>
        );
    };

    // const removeTemplate = () => {
    //     return <i className="pi pi-times" style={{ fontSize: "2em" }}></i>;
    // };

    const countryClicked = () => {
        history.push("/addcountrymanagement");
    };

    const handledClicked = () => {
        history.push("/addprovincemanagement");
    };

    const leftContents = (
        <React.Fragment>
            <h1 className="Country__Heading">Province Management</h1>
        </React.Fragment>
    );

    const rightContents = (
        <React.Fragment>
            <div className="Top__Btn">
                <Button label="Add New" onClick={handledClicked} className="Btn__Dark" />
            </div>
        </React.Fragment>
    );

    return (
        <>
            <div className="CountryTop__Btn">
                <Button disabled={loading} onClick={countryClicked} label="Country Management" className="Btn__Dark" />
                <Button disabled={loading} onClick={handledClicked} label="Province Management" className="Btn__Dark" />
                <Button disabled={loading} onClick={handledClicked} label="City Management" className="Btn__Dark" />
            </div>
            <Toolbar left={leftContents} right={rightContents} />
            <div className="card p-datatable-sm">
                <DataTable scrollable value={myData} loading={loading} selection={selectedCustomers} onSelectionChange={(e) => setSelectedCustomers(e.value)} onRowSelect={onRowSelect} paginator rows={6} emptyMessage="No data found.">
                    <Column selectionMode="multiple" header="Select" headerStyle={{ width: "3em" }}></Column>
                    <Column filter field="provinceId" header="ID" />
                    <Column filter field="provinceName" header="Province Name" />
                    <Column filter field="provinceCode" header="Province Code" />
                    <Column body={switchTemplate} header="Active" />
                    <Column body={switchTemplate} header="Approve" />
                    <Column body={actionTemplate} header="Action" />
                    {/* <Column body={removeTemplate} header="Delete" /> */}
                </DataTable>
            </div>
            <div className="Down__Btn">
                <Button label="Delete" onClick={(e) => handleAddNewSubDetails(e, "R")} className="Btn__Transparent" />
                <Button disabled={loading} onClick={(e) => handleAddNewSubDetails(e, "A")} label="Approve" className="Btn__Dark" />
            </div>
        </>
    );
}

export default ProvinceManagement;
